export default "__VITE_ASSET___vCzZ7Ky__"